import React, { forwardRef } from 'react';
import useSelector from '../../redux/typedHooks';
import { MegaMenuType } from '../../../../types/globalSettingsType';
import MenuSection from './MenuSection/MenuSection';
import HighlightedLinks from './HighlightedLinks/HighlightedLinks';
import { RoadsideAssistanceButton } from '../RoadsideAssistanceButton/RoadsideAssistanceButton';
import MegaMenuOverlayError from './MegaMenuOverlayError/MegaMenuOverlayError';
import * as S from './MegaMenuOverlay.styles';

interface MegaMenuOverlayProps {
  menuOffset: number;
  isMenuOpen?: boolean;
}

const MegaMenuOverlay = forwardRef<HTMLDivElement, MegaMenuOverlayProps>(({ menuOffset, isMenuOpen }, ref) => {
  const megaMenu: MegaMenuType | Record<string, never> = useSelector(
    (state) => state.globalSettings.settings?.megaMenu,
  );
  const highlightedLinks = useSelector((state) => state.globalSettings.settings?.highlightedLinks);
  const megaMenuSections = Object.values((megaMenu ?? {}) as MegaMenuType).filter((section) => section?.links?.length);

  if (!megaMenu || Object.keys(megaMenu).length === 0) {
    return <MegaMenuOverlayError menuOffset={menuOffset} isMenuOpen={isMenuOpen} />;
  }

  return (
    <S.Wrapper id="site-megamenu" $menuOffset={menuOffset} aria-label="Hovedmeny" ref={ref} $isMenuOpen={isMenuOpen}>
      <S.Content>
        <S.StyledGrid>
          {megaMenuSections.map((section, index) => (
            <MenuSection key={section.header ?? index} megaMenuSection={section} />
          ))}
          <S.HighlightedLinksWrapper>
            {highlightedLinks?.map((item, index) => (
              <HighlightedLinks key={item?.key ?? item?.link?.header ?? index} link={item} />
            ))}
            <S.RoadsideAssistanceButtonWrapper>
              <RoadsideAssistanceButton />
            </S.RoadsideAssistanceButtonWrapper>
          </S.HighlightedLinksWrapper>
        </S.StyledGrid>
      </S.Content>
    </S.Wrapper>
  );
});

export default MegaMenuOverlay;
